/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/reglements${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/reglements/${id}`, "GET"),

    create: async (data) => exeRequest(`/admin/reglements`, "POST", data),

    update: async (id, data) => exeRequest(`/admin/reglements/${id}`, "PUT", data),

    delete: async (id) => exeRequest(`/admin/reglements/${id}`, "DELETE"),

    getParPeriode: async (params) => exeRequest(`/admin/reglements/par-periode${buildQuery(params)}`, "GET"),

    etatParContrat: async (params) => exeRequest(`/admin/reglements/etat/par-contrat${buildQuery(params)}`, "GET"),

    etatParClient: async (params) => exeRequest(`/admin/reglements/etat/par-client${buildQuery(params)}`, "GET"),

    etatParPeriode: async (params) => exeRequest(`/admin/reglements/etat/par-periode${buildQuery(params)}`, "GET"),

    etatDetailClient: async (clientId) => exeRequest(`/admin/reglements/etat/detail-client/${clientId}`, "GET"),
};
